import { CommonEnums } from '../../common.enums';

export class Fldr {
    fldr_Id: number;
    nm: string;
    description: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    reusableFlag: string;
    error_Cd: string;
    error_Msg: string;
    change_Ind: string;
    org_Id: number;
    org_Nm: string;
    isFavourite: string;
    imageUrl: string;
    fldr_Cd: string;
    versionControlFlg: string;
    codeWalkthroughFlag: string;
    constructor() {
        this.setDefaults();
    }

    static parse(object: any): Fldr {
        let fldr: Fldr = new Fldr();
        fldr.copyFrom(object as Fldr);
        return fldr;
    }

    setDefaults() {
        this.fldr_Id = -1;
        this.nm = "";
        this.description = "";
        this.updateBy = "";
        this.lastUpdateBy = "";
        this.updateDt = new Date();
        this.reusableFlag = "N";
        this.error_Cd = "0";
        this.error_Msg = "";
        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.org_Id = -2;
        this.org_Nm = "Default";
        this.isFavourite = "N";
        this.imageUrl = "assets/icons/common/folder.svg";
        this.fldr_Cd = "Y";
        this.versionControlFlg = "N";
        this.codeWalkthroughFlag = "N";
    }

    getPrimaryKey(): string {
        return this.fldr_Id.toString();
    }

    copy(): Fldr {
        let fldrTmp: Fldr = new Fldr();

        fldrTmp.fldr_Id = this.fldr_Id;
        fldrTmp.nm = this.nm;
        fldrTmp.description = this.description;
        fldrTmp.updateBy = this.updateBy;
        fldrTmp.lastUpdateBy = this.lastUpdateBy;
        fldrTmp.updateDt = this.updateDt;
        fldrTmp.reusableFlag = this.reusableFlag;
        fldrTmp.error_Cd = this.error_Cd;
        fldrTmp.error_Msg = this.error_Msg;
        fldrTmp.change_Ind = this.change_Ind;
        fldrTmp.org_Id = this.org_Id;
        fldrTmp.org_Nm = this.org_Nm;
        fldrTmp.isFavourite = this.isFavourite;
        fldrTmp.imageUrl = this.imageUrl;
        fldrTmp.fldr_Cd = this.fldr_Cd;
        fldrTmp.versionControlFlg = this.versionControlFlg;
        fldrTmp.codeWalkthroughFlag = this.codeWalkthroughFlag;
        return fldrTmp;
    }

    copyFrom(fldrTmp: Fldr): void {
        this.fldr_Id = fldrTmp.fldr_Id;
        this.nm = fldrTmp.nm;
        this.description = fldrTmp.description;
        this.updateBy = fldrTmp.updateBy;
        this.lastUpdateBy = fldrTmp.lastUpdateBy;
        this.updateDt = fldrTmp.updateDt;
        this.reusableFlag = fldrTmp.reusableFlag;
        this.error_Cd = fldrTmp.error_Cd;
        this.error_Msg = fldrTmp.error_Msg;
        this.change_Ind = fldrTmp.change_Ind;
        this.org_Id = fldrTmp.org_Id;
        this.org_Nm = fldrTmp.org_Nm;
        this.isFavourite = fldrTmp.isFavourite;
        this.imageUrl = fldrTmp.imageUrl;
        this.fldr_Cd = fldrTmp.fldr_Cd;
        this.versionControlFlg = fldrTmp.versionControlFlg;
        this.codeWalkthroughFlag = fldrTmp.codeWalkthroughFlag;
    }

    compare(fldrTmp: Fldr): string {
        let fldrString: string = this.toString(false);
        let fldrtmpString: string = fldrTmp.toString(false);

        if (fldrString != fldrtmpString) {
            return fldrString + ', ' + fldrtmpString;
        }
        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Fldr[fldr_Id=" + this.fldr_Id +
            ",nm=" + this.nm +
            ",description=" + this.description +
            ",updateBy=" + this.updateBy +
            ",lastUpdateBy=" + this.lastUpdateBy +
            ",updateDt =" + this.updateDt +
            ",reusableFlag =" + this.reusableFlag +
            ",error_Cd =" + this.error_Cd +
            ",error_Msg =" + this.error_Msg +
            ",change_Ind =" + this.change_Ind +
            ",org_Id =" + this.org_Id +
            ",org_Nm =" + this.org_Nm +
            ",isFavourite = " + this.isFavourite +
            ",imageUrl =" + this.imageUrl +
            ",fldr_Cd = " + this.fldr_Cd +
            ",versionControlFlg =" + this.versionControlFlg +
            ", codeWalkthroughFlag =" + this.codeWalkthroughFlag;
            
        if (isNotCompare) {
            str += ''
        }

        str += ']';
        return str;
    }

}